import React, { useEffect, useRef, useState } from "react";
import { Form, ListGroup } from "react-bootstrap";
import styled from "styled-components";
import { useIsMount } from "../hooks/UseIsMount";
import CustomSpinner from "../generic/CustomSpinner";

const TableContainer = styled.div`
  max-height: 200px;
  overflow-x: auto;
  overflow-y: visible;
  position: absolute;
  z-index: 999;
  width: 100%;
  border: 1px solid grey;
  border-radius: 0.25rem;
  background-color: ${() => "#e3dae17a"};
`;

// Componente SearchObserver modificado para no tener que usar ni paginacion ni useForm
// Se usa en el formulario de cargos de la familia teresiana para escoger a quien asignar el puesto
export const SearchSelectFamily = ({
    locked,
    optionsOriginal,
    defaultValue,
    setOptionParentExt,
    setOptionParentSister,
    reset
}) => {
    const [options, setOptions] = useState(optionsOriginal);
    const [searchValue, setSearchValue] = useState("");
    const [optionValue, setOptionValue] = useState("");
    const [loading, setLoading] = useState(false);
    const [focused, setFocused] = useState(false);
    const isMount = useIsMount();
    const scrollingDiv = useRef(null);
    const divRef = useRef(null);

    // Para establecer el valor por defecto
    useEffect(() => {
        if (!searchValue && (defaultValue?.externoId || defaultValue?.sisterId) && !optionValue) {
            setSearchValue(defaultValue?.externo ?
                `${defaultValue?.externo.name} ${defaultValue?.externo.firstSurname} ${defaultValue?.externo.secondSurname ? defaultValue?.externo.secondSurname : ''}`
                :
                `${defaultValue?.sister.user.name} ${defaultValue?.sister.user.firstSurname} ${defaultValue?.sister.user.secondSurname ? defaultValue?.sister.user.secondSurname : ''}`)
            setOptionValue(defaultValue?.externo ? defaultValue?.externo.id : defaultValue?.sister.id);
        }

    }, []);

    // Para resetear el search observer
    useEffect(() => {
        !isMount && resetSearchSelect();
    }, [reset]);

    // Use Effect controla que se clicke fuera del div
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (divRef.current && !divRef.current.contains(event.target)) {
                setFocused(false);
            }
        };
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        // Reseteamos el componente si se clicka fuera también
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [divRef]);

    // UEF para controlar cuando se desfocusea que se limpie el valor de la búsqeuda o cuando se focusea se resetee
    // useEffect(() => {
    //     // Opcion actual del search select
    //     let actualOption = options.find((element) => element.value === optionValue);
    //     // Si se focusead eliminamos search value
    //     if (focused) {
    //         resetSearchSelect();
    //     }
    //     // Si cerramos y no tenemos marcado ninguna opcion
    //     if (!actualOption && !focused) {
    //         resetSearchSelect();
    //     }
    // }, [focused]);

    // Cuando se haga una búsqueda volvemos a pedir desde el principio
    const searchAction = async (mySearchValue) => {
        setLoading(true);
        setOptions(null)
        setOptions(optionsOriginal.filter(o => `${o.name} ${o.firstSurname} ${o.secondSurname}`.toLowerCase().includes(mySearchValue.toLowerCase())));
        setLoading(false);

    };

    // Función para asignar un value y un name a los inputs cuando se selecciona un valor de la lista
    // option => Valores a asignar
    const setSearchAndOptionValues = (option) => {
        setSearchValue(`${option.name} ${option.firstSurname} ${option.secondSurname} `);
        setOptionValue(option.id);
        option.type === 'ext' ?
            setOptionParentExt(option.id) :
            setOptionParentSister(option.id);
    };

    // Devuelve una lista de botones que hacen referencia a las opciones del select
    // options  => Opciones a tener en cuenta


    // Función que resetea el componente
    const resetSearchSelect = () => {
        setSearchValue("");
        setOptionValue("");
    };

    const manejadorBusqueda = (e) => {
        setSearchValue(e.target.value);
        searchAction(e.target.value);

    }

    return (
        <div ref={divRef} className="position-relative flex-grow-1">
            <CustomSpinner loading={loading} animation={"border"} />
            {/*Input que tendrá el value de la opción seleccionada  NO SE VE*/}
            <Form.Control className={"d-none"} type="text" value={optionValue} readOnly />
            {/*Input que tendrá el nombre de la opción seleccionada */}
            <Form.Control
                readOnly={!locked}
                required
                name="mySearchSelectName"
                type="text"
                placeholder="Busque y seleccione (distingue tildes)"
                onFocus={() => {
                    setFocused(true);
                }}
                value={searchValue}
                onChange={manejadorBusqueda}
                autocomplete="off"
            />

            {/*Lista con botones que mostrará las opciones del select */}
            <TableContainer className={focused ? "" : "d-none"} ref={scrollingDiv}>
                <ListGroup>{
                    options.map((option) => {
                        return <ListGroup.Item
                            action
                            key={`${option.id}-${option.type}`}
                            onClick={(e) => {
                                e.preventDefault();
                                setSearchAndOptionValues(option);
                                setFocused(false);
                            }}
                        >
                            {option.component ? option.component : `${option.name} ${option.firstSurname} ${option.secondSurname ? option.secondSurname : ''}`}
                        </ListGroup.Item>
                    })
                }

                </ListGroup>
            </TableContainer>
        </div>
    );
};
